import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/da/offlineanalysis/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/da/offlineanalysis/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/offlineanalysis/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/offlineanalysis/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/da/offlineanalysis/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/da/offlineanalysis/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

